import { MenuFoldOutlined, MenuUnfoldOutlined, IdcardOutlined, MenuOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, MenuProps } from 'antd';
import { Header } from 'antd/es/layout/layout';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import DrawerMenu from 'components/organisms/DrawerMenu';
import MenuComponent from 'components/organisms/MenuComponent';
import { AuthProvider } from 'components/protected/ProviderAuth';
import { COOKIE_KEYS } from 'config/cookieConstants';
import authStore from 'stores/auth/AuthStore';
import './styles.scss';
import { AppRoutes } from 'routes/AppRoutes';

interface MainLayoutContentProps {
    setIsDarkMode: () => void;
}

const MainLayoutContent: React.FC<MainLayoutContentProps> = ({ setIsDarkMode }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const navigate = useNavigate();
    const selectedCompany = authStore.selectedCompany;
    const email = Cookies.get(COOKIE_KEYS.EMAIL);

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <p onClick={() => navigate(AppRoutes.SELECT_COMPANY)}>
                    Selecionar empresa
                </p>
            ),
        },
        {
            key: '2',
            label: (
                <p onClick={() => authStore.logout()}>
                    Desconectar
                </p>
            ),
        },

    ];

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    return (
        <>
            <div className="h-screen overflow-hidden flex">
                <div className="custom-menu hidden lg:block">
                    <MenuComponent collapsed={collapsed} />
                </div>

                <div className={`inline-block w-full lg:w-3/4 align-top`} style={{
                    width: '100%',
                    ...(window.innerWidth >= 768 && { width: 'calc(100%)' })
                }}>
                    {/* Header Web */}
                    <div className="hidden lg:block">
                        <Header className="header border-b dark:bg-midnight dark:border-0 ">

                            <div className="flex gap-3 items-center lg:block">
                                <div>
                                    {
                                        collapsed
                                            ? <MenuUnfoldOutlined className="dark:text-white" onClick={toggleCollapsed} />
                                            : <MenuFoldOutlined className="dark:text-white" onClick={toggleCollapsed} />
                                    }
                                </div>
                            </div>

                            <div className="flex gap-6 flex-row">
                                <Dropdown className="flex items-center cursor-pointer" menu={{ items }} placement="bottomLeft" arrow>
                                    <div className="flex gap-3" onClick={(e) => e.preventDefault()}>
                                        <Avatar
                                            className='bg-inherit border-gray-500 border-2 text-gray-500'
                                            size={40}
                                            icon={<IdcardOutlined style={{ fontSize: "24px" }} />}
                                        />


                                        <div className='flex flex-col justify-center items-start ' style={{ lineHeight: '1.2' }}>
                                            <b><h3>{selectedCompany?.features.onScreenName}</h3></b>
                                            <span className="dark:text-white">{email}</span>
                                        </div>
                                    </div>
                                </Dropdown>
                            </div>
                        </Header>
                    </div>

                    {/* Header Mobile */}
                    <div className="flex items-center lg:hidden header-mobile border-b">
                        <div onClick={() => setOpenMenu(true)}>
                            <MenuOutlined className='text-gray-500' />
                        </div>
                    </div>

                    <div className="box dark:bg-midnight">
                        <Outlet />
                    </div>
                </div>
            </div>

            <DrawerMenu setOpenMenu={setOpenMenu} openMenu={openMenu} />
        </>
    );
};

interface MainLayoutProps {
    setIsDarkMode: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ setIsDarkMode }) => {
    return (
        <AuthProvider>
            <MainLayoutContent setIsDarkMode={setIsDarkMode} />
        </AuthProvider>
    );
};

export default MainLayout;